import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { oidcAuthApi } from './oidcAuthApi';
import { oidcSignInPage } from './oidcSignInPage';

/**
 * Frontend module that:
 *   1. Registers an `auth.oidc` ApiFactory backed by `OAuth2`, since
 *      `@backstage/core-plugin-api` does not ship a generic `oidcAuthApiRef`.
 *   2. Replaces the default sign-in page with a `SignInPage` configured for
 *      auto-redirect to the OIDC provider.
 *
 * Registered via `createApp({ features: [...] })` in
 * `packages/app/src/App.tsx`.
 */
export const oidcAuthModule = createFrontendModule({
  pluginId: 'app',
  extensions: [oidcAuthApi, oidcSignInPage],
});
